(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["scroll-menu"] && !window.DesignMode) return;
  try {
    

var titles = document.getElementsByClassName("faq-header");
var last = null;
list = document.getElementById('list');
for(let i = 0; i < titles.length; i++){
  title = titles[i].innerText;

  let a = document.createElement('a');
  a.id = title+i
  a.href = "#"+title;
  a.innerText = title;
  a.onclick = function(e) {smoothScroll(e);};
  a.classList.add("link-list","li");
  list.appendChild(a);
};

function smoothScroll(e){
  e.preventDefault();

  last = document.getElementsByClassName("link-list--highlight");
  console.log(last);
  menuIndicator(e, last);

  var id = e.target.getAttribute('href').replace('#','');
  var heading = document.getElementById(id);
  heading_y = heading.offsetTop - 130;
  window.scrollTo({
    top: heading_y,
    left: 0,
    behavior: 'smooth'
  });
};

function menuIndicator(e, last){
  if (last[0] != null){
    elem = document.getElementById(last[0].id);
    elem.classList.remove("link-list--highlight");
  };
  e.path[0].classList.add("link-list--highlight");
};


  } catch(e) { console.error(e); }
})();

})();
